import { render, staticRenderFns } from "./DialogPageChatDetail.vue?vue&type=template&id=7f020912"
import script from "./DialogPageChatDetail.vue?vue&type=script&lang=js"
export * from "./DialogPageChatDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports